const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|^$|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const EMAIL_MAX_LENGTH = 80;
const NAME_REGEX = /^[^@]+$/i;
const NAME_MAX_LENGTH = 30;
const SURNAME_REGEX = /^[^@]+$/i;
const SURNAME_MAX_LENGTH = 30;
const PHONENUMBER_REGEX = /^((\+\d{1,3}))[0-9\s]{10,20}$/;
const PHONENUMBER_MAX_LENGTH = 20;

export default class InputValidator {
  private static validateInput (
    input: string,
    rgx: RegExp,
    length: number
  ): boolean {
    return rgx.test(String(input).toLowerCase()) &&
    input.length <= length;
  }

  static validateEmail (email: string): boolean {
    return this.validateInput(email, EMAIL_REGEX, EMAIL_MAX_LENGTH);
  }

  static validateName (name: string): boolean {
    return this.validateInput(name, NAME_REGEX, NAME_MAX_LENGTH);
  }

  static validateSurname (surname: string): boolean {
    return this.validateInput(surname, SURNAME_REGEX, SURNAME_MAX_LENGTH);
  }

  static validatePhoneNumber(phoneNumber: string): boolean {
    return this.validateInput(phoneNumber, PHONENUMBER_REGEX, PHONENUMBER_MAX_LENGTH);
  }
}
